import _Guest from "./_Guest";
import _BookingEngine from "./_BookingEngine";
import _Books from "./_Books";

export const ModuloHotelAPI = {
    BookingEngine: _BookingEngine,
    Guest: _Guest,
    Books: _Books
}